import { createFileRoute } from "@tanstack/react-router";
import KontaktPage from "@/pages/KontaktPage";
import { buildRouteHead } from "@/lib/route-head";

export const Route = createFileRoute("/kontakt")({
  head: () =>
    buildRouteHead({
      title: "Kontakt | Agentur Enno & Jens aus Wernigerode",
      description:
        "Kontaktieren Sie Ihre Agentur aus Wernigerode im Harz. Kostenlose Erstberatung für Webdesign, SEO und Digitalisierung.",
      path: "/kontakt",
      image: "/images/hero-bg-1280.webp",
      imageAlt: "Kontakt zur Agentur Enno & Jens",
      imageWidth: 1280,
      imageHeight: 720,
    }),
  component: KontaktPage,
});
